import { FC, useMemo } from 'react';
import { Chip, ChipProps } from '@mui/material';

import { useDictionary } from '@cvt/hooks/useDictionary';

import { getMeetingStatusLabel, getMeetingStatusColor } from '../helpers/meeting';


type Props = {
    status?: Meetings.MeetingStatus;
}

export const MeetingStatusChip: FC<Props> = (props) => {
  const { status } = props;
  const dictionary = useDictionary();

  const currentStatus = useMemo(() => {
    if (status) {
      return {
        label: getMeetingStatusLabel(dictionary, status),
        color: getMeetingStatusColor(status),
      };
    }
  }, [dictionary, status]);

  return (
    <Chip
      label={currentStatus && currentStatus.label}
      color={currentStatus && currentStatus.color as ChipProps['color']}
      size="small"
      sx={{
        fontWeight: 600,
        fontSize: 12,
        color: 'white',
      }}
    />
  );
};
